import { translationLanguageOptions } from '../../../data/translation-language-options';
import { fontFamilyConfigModel } from './font-family-config.model';
import { fontSizeConfigModel } from './font-size-config.model';
import { headingConfigModel } from './heading-config.model';
import { textPartLanguageConfigModel } from './langauge-config.model';
import { lineHeightConfigModel } from './line-height-config.model';

export const ckEditorConfig = {
    // @TODO: get a commercial license?
    licenseKey: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
    fontFamily: fontFamilyConfigModel,
    fontSize: fontSizeConfigModel,
    lineHeight: lineHeightConfigModel,
    heading: headingConfigModel,
    language: {
        ui: 'fr',
        textPartLanguage: JSON.parse(JSON.stringify(textPartLanguageConfigModel))
    },
    agprPrCoPilot: {
        showAiHelper: true,
        showPrCoPilotBalloon: true
    },
    translationLanguages: translationLanguageOptions,
    htmlSupport: {
        allow: [
            {
                name: /.*/,
                attributes: true,
                classes: true,
                styles: true
            }
        ]
    }
} as any;
